export const samlLoginUrl: string = `/api/auth/v1/saml/login`;
export const validateUserApi = `/api/auth/v1/validate-user?email=`;
export const sessionStatusUrl: string = `/api/auth/v1/session-status`;
export const logoutUrl: string = `/api/auth/v1/saml/logout`;
export const applicationUrl: string = `/api/auth/v1/applications`;
export const resendOtpApi = `/api/auth/v1/resend-otp`;
export const validateOtpApi = `/api/auth/v1/validate-otp`;

export const AUTHORISED_USERS_NOTICE = `This computer system is for authorised users only. Individuals using this system without authority or in
excess of their authority are subject to having all their activities on this system monitored and recorded
or examined by any authorised person, including law enforcement, as system personnel deem appropriate. In
the course of monitoring individuals improperly using the system or in the course of system maintenance,
the activities of authorised users may also be monitored and recorded. Any material so recorded may be
disclosed as appropriate. Anyone using this system consents to these terms.`;

export const PRIVACY_NOTICE = `Our online data privacy notice describes how we may collect, use and share information you provide through
your engagement with our services.`;
